import { useTranslation } from 'react-i18next';

export const keyPrefix = 'role_filters';
export const useFilterRoleTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Название',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Name',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Nombre',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    input: {
      placeholder: 'Nome',
    },
  },
}) : {}) as Record<string, unknown>;
